import React from "react";
import "./index.css";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Container } from "react-bootstrap";

const Refund = () => {
  return (
    <div className="terms_section">
      <div className="terms">
        <Header />
        <Container>
          <h4>
            <b>REFUND & CANCELLATION POLICY</b>
          </h4>
          <h6 className="py-5">
            <b>
              Note: THIS DOCUMENT IS AN ELECTRONIC RECORD IN TERMS OF THE INFORMATION TECHNOLOGY
              ACT, 2000 AND RULES MADE THEREUNDER. THIS ELECTRONIC RECORD IS GENERATED BY A COMPUTER
              SYSTEM AND DOES NOT REQUIRE ANY PHYSICAL OR DIGITAL SIGNATURES. THESE TERMS OF USE
              WERE UPDATED ON NOVEMBER 2021. PLEASE CAREFULLY READ THESE TERMS OF USE. BY USING THIS
              PLATFORM, YOU INDICATE YOUR UNDERSTANDING AND ACCEPTANCE OF THESE TERMS. IF YOU DO NOT
              AGREE TO THESE TERMS, YOU MAY NOT USE THIS PLATFORM
            </b>
          </h6>
          <ol type="a">
            <li>
              No Refund of creator/ merchant and/or end user shall be granted by the company. All
              refunds are strictly basis the brand's terms and conditions.
            </li>
            <li>
              In the event the merchant or creator wants to stop the subscription or service
              provided by the company, the creator or merchant shall use the tools provided on the
              platform.
            </li>
            <li>
              Any Account inactive for 60 days will automatically be deleted. The company shall not
              be liable for deletion of contents or de-activation of such dormant accounts.
            </li>
            <li>
              Brands for marketing / PPC campaigns, cannot withdraw any funds added to the system.
              Unused balance can be used by the brand in subsequent campaigns. In the scenario of
              the brand terminating its contract with the platform, a formal request for a refund of
              the balance can be made to the app management team. Any refund granted is at the sole
              discretion of the company.
            </li>
          </ol>
          <p>Escalation Desk</p>
          <div className="no-space">
            <p>Splendid App Private Limited,</p>
            <p>
              Address: 235, Binnamangala, 2nd Floor 13th Cross Road, 2nd Stage Indiranagar
              (Bangalore) Bangalore North Bangalore KA 560038 IN.
            </p>
            <p>
              Contact us: <a href="mailto:hello@splendid.app">hello@splendid.app</a>
            </p>
            <p>Time: Mon - Fri (11:00 - 18:00)</p>
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Refund;
